import { RoomLevel, RoomType } from 'types/reso';
import lengthConverter from 'utils/length-converter';

export type RoomSerializableProperties = ReturnType<typeof Room.prototype.toJSON>;

export class Room {
  public static readonly SIZE_NOT_AVAILABLE_LABEL = 'Not available' as const;
  type: RoomType | null;
  level: RoomLevel | null;
  width: number | null;
  length: number | string | null;
  unit: string | null;
  dimensions: string | null;
  flooring: string | null;

  constructor(room: Record<string, unknown>) {
    this.type = room?.type as RoomType | null ?? null;
    this.level = room?.level as RoomLevel | null ?? null;
    this.width = room?.width as number | null ?? null;
    this.length = room?.length as number | string | null ?? null;
    this.unit = room?.unit as string | null ?? null;
    this.dimensions = room?.dimensions as string | null ?? null;
    this.flooring = room?.flooring as string | null ?? null;
  }

  toJSON() {
    return {
      type: this.type,
      level: this.level,
      width: this.width,
      length: this.length,
      unit: this.unit,
      dimensions: this.dimensions,
      flooring: this.flooring,
    };
  }

  size = (desiredUnit: string): string | typeof Room.SIZE_NOT_AVAILABLE_LABEL => {
    const { unit, width, length, dimensions } = this;
    if (width && length && unit) {
      return `${lengthConverter(width, unit, desiredUnit)} × ${lengthConverter(Number(length), unit, desiredUnit)} ${desiredUnit === 'feet' ? 'ft' : 'm'}`;
    } else if (dimensions) {
      return dimensions;
    } else {
      return Room.SIZE_NOT_AVAILABLE_LABEL;
    }
  };
}